export const register = {
  field: {
    currency: 'Mata uang',
    email: 'Alamat e-mail',
    phone_number: 'Nomor telephone',
    terms: 'Syarat dan Ketentuan'
  },
  button: {
    check_code: 'Konfirmasi',
    continue: 'Bersambung',
    create_account: 'Buat account',
    new_code: 'Kode baru',
    recovery_password: 'Password Recovery ',
    register: 'Daftar',
    use_different_number: 'Gunakan nomor telepon lainnya',
    change_number: 'Change number',
    resend: 'Kirim ulang'
  },
  error: {
    1001: 'Batas permintaan kode SMS terlampaui per menit, silakan coba lagi nanti',
    1002: 'Batas permintaan kode SMS terlampaui per jam, silakan coba lagi nanti',
    1003: 'Permintaan verifikasi nomor tidak ditemukan',
    1004: 'Kode konfirmasi tidak valid',
    1005: 'Invalid confirmation code',
    something_went_wrong: 'Ada kemungkinan kesalahan',
    email: 'Alamat email sudah digunakan orang lain.',
    phone: 'Telepon sudah diambil.'
  },
  modal: {
    registration_successfully: 'Registrasi berhasil',
    registration_successfully_text:
      '<span style="display: block">Terima kasih sudah registrasi.</span><span>Login data dikirim ke e-mail Anda</span>'
  },
  confirm: {
    title: 'Konfirmasi',
    text: 'Kami telah mengirimkan kode konfirmasi ke',
    sending_sms: 'Mengirim SMS',
    change_number_text: 'Anda yakin ingin mengirim ulang kode konfirmasi ke',
    acc_configured: `Menyiapkan akun. <br> Ini akan memakan waktu kurang dari satu menit`
  },
  events: {
    welcome: `Terima kasih atas pendaftarannya! <br>Kredensial akun telah dikirim ke email Anda. <br>Anda juga memiliki 5 dolar selamat datang di akun Anda.`,
    fail:
      'Terjadi kesalahan selama pendaftaran. Informasi tambahan telah dikirim ke email yang ditentukan.',
    timeout:
      'Terjadi kesalahan selama pendaftaran. Silakan hubungi tim dukungan kami. Kami akan membantu Anda memecahkan masalah Anda.'
  },
  change_not_possible: 'Tidak dapat dirubah',
  choose_currency:
    'Pilih mata uang yang paling nyaman bagi Anda untuk membuat kalkulasi dan menerima statistik dan laporan keuangan.',
  email_address: 'Alamat e-mail',
  i_agree: 'Saya setuju ',
  log_in: 'LOG IN',
  phone_verified: 'Nomor telephone verifikasi',
  phone_verify_code: 'kode verifikasi SMS ',
  terms_and_conditions: 'Syarat dan Ketentuan',
  have_acc: 'Sudah memiliki akun?',
  private_registration_title: 'Pendaftaran privat',
  private_registration_text: 'Hubungi kami untuk mendaftarkan akun',
  private_registration_button: 'Hubungi kami'
};
